import { EditIcon } from "../icons/EditIcon";

function CardRevisionCount({ 
    count = 0, 
    withIcon = false 
}) {
    if (count <= 0) {
        return null;
    }

    if(withIcon) {
        return (
            <div className='d-flex align-items-center'>
                <EditIcon color="#727580" height={16} width={16} className={'me-1'}/>
                <span>{count}</span>
            </div>
        )
    }

    return count
}
export { CardRevisionCount };